// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-63ac2f2e] .intl-phone-input{width:100%}[data-v-63ac2f2e] .intl-phone-input input[type=text]{border:1px solid rgba(197,214,222,.7);box-shadow:none}", ""]);
// Exports
module.exports = exports;
